import { BrickContext, Brick, registerBrick, QueryResult } from 'olympe';

export default class PriceSum extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {QueryResult} expenses
     * @param {function(Array)} setAmounts
     */
    update($, [expenses], [setAmounts]) {
        const exps = expenses.toArray().map(e => e.toJSON())
        const currencies = [];
        exps.forEach(expense => {
            const curInstance = currencies.find(c => c.currency === expense.currency);
            if (curInstance) {
                curInstance.amount += expense.amount + (expense.amount2 ?? 0) + (expense.amount3 ?? 0)
            } else {
                currencies.push({currency: expense.currency, amount: expense.amount + (expense.amount2 ?? 0) + (expense.amount3 ?? 0)})
            }
        })
        setAmounts(currencies);
    }
}

registerBrick('01936c6d0d3eec909ba5', PriceSum);
